export ChannelTab from './ChannelTab';
export ExportTab from './ExportTab';
export ManagementTab from './ManagementTab';
// export PresentationTab from './PresentationTab';
// export LocationTab from './LocationTab';
// export FeaturesTab from './FeaturesTab';
// export PicturesTab from './PicturesTab';
export ModalCreateGroup from './ModalCreateGroup';
export ModalCreateOwner from './ModalCreateOwner';
export UnitsFieldset from './UnitsFieldset';
// export ZonesAreasSelector from './ZonesAreasSelector';



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/index.js